import { useEffect, useRef, useState } from 'react'
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { jsPDF } from 'jspdf'
import styles from './housekeeping.module.css'
import './Fonts/Signika-Regular-normal'
import { getCheckInOutForm, updateCheckInOutForm, useAuth, useCheckInOutFormList, useCurrentEvent, useLocations} from '../firebase/firebase'
import levenshtein from 'js-levenshtein';


export default function CheckInOutForm({ setShowNavBar }) {
    const [, accountDetails] = useAuth();
    const [searchParams, ] = useSearchParams();

    const id = searchParams.get('id');
    const toCheckOut = searchParams.get('check-out') ?? false;

    return (
        (accountDetails?.account_area === 'Housekeeping' || accountDetails?.account_area === 'Development' ||
        accountDetails?.account_area === 'Administration') && (id != null) ?
            <StaffView setShowNavBar={setShowNavBar} formId={id} toCheckOut={toCheckOut}/> :
            <ChurchView setShowNavBar={setShowNavBar}/>
    )                
}

function ChurchView({ setShowNavBar }) {
    const [searchParams, ] = useSearchParams();
    const cabin = searchParams.get('cabin');

    const [name, setName] = useState("");
    const [churchName, setChurchName] = useState("");
    const [selectedCabin, setSelectedCabin] = useState(cabin ?? "")

    const navigate = useNavigate();
    const currentEvent = useCurrentEvent();
    const cabins = filterCabins(useLocations());

    useEffect(() => setShowNavBar(false));

    const formSubmitted = (e) => {
        e.preventDefault();
        console.log('Event: ', e);

        const data = {
            event_name: currentEvent?.name ?? 'UNKNOWN',
            event_id: currentEvent?.id ?? 'UNKNOWN',

            group: e.target[0].value,
            cabin: e.target[1].value,
            gender: e.target[2].value,
            bed_numbers: e.target[3].value,
            status: 'Checked In',

            check_in: {
                broom: e.target[4].checked,
                dust_pan: e.target[5].checked,
                waste_can: e.target[6].checked,
                major_damages: e.target[7].value,
                counselor: e.target[8].value,
                date: e.target[9].value,
            }           
        }
        console.log('Parsed Data: ', data);

        updateCheckInOutForm(undefined, data,
            (ref) => {
                navigate(`/check-in-out-form/submitted?id=${ref.id}`);
            },
            (err) => {
                window.alert('There was an issue when submitting your form.\nPlease visit the current events check-in location or camp office.');
                console.error(err);
            });
    }

    return (
        <form className={styles.container} id={styles.churchview} onSubmit={(e) => formSubmitted(e)}>
            <div id={styles.heading}>
                <div id={styles.header}>
                    <h1>Cabin Check In/Out Form</h1>
                    <p>{currentEvent?.name ?? ''}</p>
                </div>                
                <div id={styles.top_box}>
                    <label htmlFor="church-name" style={{gridArea: '1/1/1/1'}}>Group</label>
                    {
                        currentEvent?.groups?.length > 0 ?
                        <select id="church-name" defaultValue='' required>
                            <option key='choose' value='' disabled hidden>-- Choose Group --</option>
                            {
                                currentEvent.groups.map(group => <option key={group}>{group}</option>)
                            }
                        </select>
                        :
                        <input id="church-name" style={{gridArea: '1/2/1/2'}} required onChange={(e) => setChurchName(e.target.value)}/>
                    }
                    <label htmlFor="cabin-name" style={{gridArea: '2/1/2/1'}}>Cabin</label>
                    {
                        cabin !== null ?
                        <select id="cabin-name" style={{gridArea: '2/2/2/2'}}>
                            <option key='only-key' value={cabin}>{cabin}</option>
                        </select> 
                        :
                        <select id="cabin-name" required defaultValue={''}  onChange={(e) => setSelectedCabin(e.target.value)} style={{gridArea: '2/2/2/2'}}>
                            <option key='choose' value={''} disabled hidden>-- Choose Cabin --</option>
                            {
                                cabins.map(type => <option key={type}>{type}</option>)
                            }
                        </select>
                    }
                    <label htmlFor="gender">Gender</label>
                    {
                        selectedCabin != "" && currentEvent?.cabin_assignments != null && currentEvent?.cabin_assignments?.[selectedCabin] != undefined ? 
                        <select id="gender" required defaultValue={''} onChange={(e) => setSelectedCabin(e.target.value)}>
                            <option key={currentEvent.cabin_assignments[selectedCabin].toLocaleLowerCase()} value={currentEvent.cabin_assignments[selectedCabin]} >{currentEvent.cabin_assignments[selectedCabin]}</option>
                        </select>
                        :
                        <select id="gender" required defaultValue=''>
                            <option key='choose' value='' disabled hidden>-- Choose Gender --</option>
                            <option key='male' value='Male'>Male</option>
                            <option key='female' value='Female'>Female</option>
                        </select>                        
                    }
                    
                    <label htmlFor="bed-numbers">Bed Numbers</label>
                    <input id="bed-numbers" required/>
                </div>
            </div>
            <div id={styles.text} className={styles.section}>
                <p>We are excited to have you as our guest and we look forward to serving you. As we strive to ensure that your time at Chautauqua is a great experience we feel it is imperative to keep our facilities clean and in working order. With this in mind, we are asking individual counselors in charge of their groups to fill out this form and turn it into the office in case we need to make any repairs.</p>
                <p>We understand that our facilities are in some cases decades old and show signs of use. Please indicate in the space provided if there are any major damages to your cabin/dorm upon your arrival. The church will be charged for damages incurred due to horseplay or inappropriate behavior. The cost of any repairs due to damage during your stay can be obtained from the office.</p>
            </div>
            <div id={styles.church_form} className={styles.section}>
                <h2>Present in Cabin:</h2>
                <p style={{fontStyle: 'italic'}}>Please check the box if the following items were in the cabin when you arrived.</p>
                <div>
                    <input type="checkbox" id="broom"/>
                    <label htmlFor="broom">Broom</label>
                    <input type="checkbox" id="dustpan"/>
                    <label htmlFor="dustpan">Dust Pan</label>
                    <input type="checkbox" id="waste-can"/>
                    <label htmlFor="waste-can">Waste Can</label>
                </div>
                <h2>Preexisting Major Damages:</h2>
                <p style={{fontStyle: 'italic'}}>Please list major damages, if any, in the space provided.</p>
                <textarea rows='4' cols='50'/>

                <div id={styles.sign_space}>
                    <div>
                        <label htmlFor='c-name'>Counselor Full Name:</label>
                        <input type="text" autoComplete='name' id='c-name' required onChange={(e) => setName(e.target.value)}/>
                    </div>
                    <div>
                        <label htmlFor='c-date'>Today's Date:</label>
                        <input type="date" id='c-date' required/>
                    </div>
                </div>
                <p id={styles.agreement}>By inputting my name and today's date, I, {name}, certify that the above information is correct to the best of my knowledge and that charges for any new damages will be paid for by {churchName}.</p>

                <input type="submit"></input>
            </div>
        </form>
    )
}
function filterCabins(locations) {
    const cabins = [];

    for(const location of locations)
        if(location.categories.includes('Cabin') && !location.name.includes('Appartment'))
            cabins.push(location.name)

    cabins.sort();

    return cabins;
}

function StaffView({ setShowNavBar, formId, toCheckOut }) {
    const [formData, setFormData] = useState({});
    const [staffName, setStaffName] = useState("");
    const [checkedOut, setCheckedOut] = useState(true);

    const checkOutRef = useRef(null);

    useEffect(() => {
        setShowNavBar(true);

        if(formId !== undefined)
            getCheckInOutForm(formId).then(data => setFormData(data));
    }, [formId]);

    useEffect(() => {
        setCheckedOut(formData?.status === 'Checked Out');
        setStaffName(formData?.check_out?.staff);

        if(toCheckOut)
            checkOutRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [formData]);

    const onStaffFormSubmitted = (e) => {
        e.preventDefault();

        const data = {
            status: 'Checked Out',

            check_out: {
                broom: e.target[0].checked,
                dust_pan: e.target[1].checked,
                waste_can: e.target[2].checked,
                major_damages: e.target[3].value,
                staff: e.target[4].value,
                date: e.target[5].value
            }
        }
        console.log('Parsed Data: ', data);

        updateCheckInOutForm(formId, data,
            () => {
                window.location.reload();
            },
            (err) => {
                window.alert('There was an issue when submitting your form.\nPlease visit the current events check-in location or camp office.');
                console.error(err);
            });
    }

    return (
        <div className={styles.container}>
            {
                formData === undefined ?
                <div>
                    <h1>Group Check In/Out Form (Staff)</h1>
                    <h1>Invalid Form ID</h1>
                    <p style={{background: '#FFFFFFA0'}}>Please verify the link is correct. If you followed a link on the Chautauqua Interconnect site, please let Whitaker Kohls know that there was an error.<br/>Thank you.</p>
                </div>                
                :
                <div>
                    <div className={styles.container} id={styles.churchview}>
                        <div id={styles.heading}>
                            <div id={styles.header}>
                                <h1>Check In/Out Form (Staff)</h1>
                                <p>Status: {formData?.status}, Event: {formData?.event_name ?? ''}</p>
                            </div>                
                            <div id={styles.top_box}>
                                <label htmlFor="church-name" style={{gridArea: '1/1/1/1'}}>Group</label>
                                <input id="church-name" style={{gridArea: '1/2/1/2'}} required defaultValue={formData?.group} disabled/>
                                <label htmlFor="cabin-name">Cabin</label>
                                <select id="cabin-name" disabled>
                                    <option>{formData.cabin}</option>
                                </select>
                                <label htmlFor="gender">Gender</label>
                                <select id="gender" disabled>
                                    <option>{formData.gender}</option>
                                </select>                
                                <label htmlFor="bed-numbers">Bed Numbers</label>
                                <input id="bed-numbers" required defaultValue={formData.bed_numbers} disabled/>
                            </div>
                        </div>
                        <div id={styles.church_form} className={styles.section}>
                            <h2>Present in Cabin (During Check In):</h2>
                            <p style={{fontStyle: 'italic'}}>Please check the box if the following items were in the cabin when you arrived.</p>
                            <div>
                                <input type="checkbox" id="broom" defaultChecked={formData?.check_in?.broom} disabled/>
                                <label htmlFor="broom">Broom</label>
                                <input type="checkbox" id="dustpan" defaultChecked={formData?.check_in?.dust_pan} disabled/>
                                <label htmlFor="dustpan">Dust Pan</label>
                                <input type="checkbox" id="waste-can" defaultChecked={formData?.check_in?.waste_can} disabled/>
                                <label htmlFor="waste-can">Waste Can</label>
                            </div>
                            <h2>Preexisting Major Damages (During Check In):</h2>
                            <p style={{fontStyle: 'italic'}}>Please list major damages, if any, in the space provided.</p>
                            <textarea rows='4' cols='50' value={formData?.check_in?.major_damages} disabled/>

                            <div id={styles.sign_space}>
                                <div>
                                    <label htmlFor='c-name'>Counselor Full Name:</label>
                                    <input type="text" autoComplete='name' id='c-name' required defaultValue={formData?.check_in?.counselor} disabled/>
                                </div>
                                <div>
                                    <label htmlFor='c-date'>Today's Date:</label>
                                    <input type="date" id='c-date' required defaultValue={formData?.check_in?.date} disabled/>
                                </div>
                            </div>
                            <p id={styles.agreement}>By inputting my name and today's date, I, {formData?.check_in?.counselor}, certify that the above information is correct to the best of my knowledge and that charges for any new damages will be paid for by {formData.group}.</p>
                        </div>
                    </div>
                    <div id={styles.staffview} className={styles.container}>
                        <form id={styles.staff_form} className={styles.section} onSubmit={(e) => onStaffFormSubmitted(e)}>
                            <h2 ref={checkOutRef}>Present in Cabin (During Check Out):</h2>
                            <p style={{fontStyle: 'italic'}}>Please check the box if the following items were in the cabin when you checked out.</p>
                            <div>
                                <input type="checkbox" id="out_broom" disabled={checkedOut}
                                    defaultChecked={formData?.check_out?.broom}/>
                                <label htmlFor="out_broom">Broom</label>
                                <input type="checkbox" id="out_dustpan" disabled={checkedOut}
                                    defaultChecked={formData?.check_out?.dust_pan}/>
                                <label htmlFor="out_dustpan">Dust Pan</label>
                                <input type="checkbox" id="out_waste-can" disabled={checkedOut}
                                    defaultChecked={formData?.check_out?.waste_can}/>
                                <label htmlFor="out_waste-can">Waste Can</label>
                            </div>
                            <h2>Preexisting Major Damages (During Check Out):</h2>
                            <p style={{fontStyle: 'italic'}}>Please list major damages, if any, in the space provided.</p>
                            <textarea rows='4' cols='50' disabled={checkedOut}
                                defaultValue={formData?.check_out?.major_damages}/>

                            <div id={styles.sign_space}>
                                <div>
                                    <label htmlFor='out_c-name'>Staff Full Name:</label>
                                    <input type="text" autoComplete='name' id='out_c-name' required disabled={checkedOut} onChange={(e) => setStaffName(e.target.value)}
                                        defaultValue={formData?.check_out?.staff}/>
                                </div>
                                <div>
                                    <label htmlFor='out_c-date'>Today's Date:</label>
                                    <input type="date" id='out_c-date' required disabled={checkedOut}
                                        defaultValue={formData?.check_out?.date}/>
                                </div>
                            </div>
                            <p id={styles.agreement}>By inputting my name and today's date, I, {staffName}, certify that the above information is correct to the best of my knowledge.</p>
                            {
                                checkedOut ? null : <input type="submit"></input>
                            }                            
                        </form>
                    </div>
                    <div id={styles.side}>
                        <div id={styles.print} onClick={() => formToPDF(formData)}/>
                    </div>                    
                </div>
            }
        </div>
    )
}

export function CheckInOutFormList({}) {
    const currentEvent = useCurrentEvent();
    const currentEventFilter = (form) => { return currentEvent?.id === form.event_id || form.event_id === 'UNKNOWN'; }
    const checkedInFilter = (form) => { return currentEventFilter(form) && form.status === 'Checked In'; }
    const checkedOutFilter = (form) => { return currentEventFilter(form) && form.status === 'Checked Out'; }
    const allFilter = () => { return true; }

    const [filter, setFilter] = useState();
    const [search, setSearch] = useState("");
    const forms = useCheckInOutFormList();

    const selectFilter = (filterName) => {
        if(filterName === 'event')
            setFilter(() => currentEventFilter);
        else if(filterName === 'in')
            setFilter(() => checkedInFilter);
        else if(filterName === 'out')
            setFilter(() => checkedOutFilter);
        else 
            setFilter(() => allFilter);
    }

    const compareForms = (a, b) => {
        if(a.check_in.date !== b.check_in.date)
            return -a.check_in.date.localeCompare(b.check_in.date);

        else if (a.status !== b.status)
            return a.status.localeCompare(b.status);

        else if (a.group !== b.group)
            return a.group.localeCompare(b.group);

        else if (a.cabin !== b.cabin)
            return a.cabin.localeCompare(b.cabin);

        return 0;
    }

    var filteredList;

    if(search !== "") {
        filteredList = forms.filter(filter ?? currentEventFilter);
        var minRank = Number.MAX_SAFE_INTEGER;

        for(const form of filteredList)
            minRank = Math.min(rankSearch(form, search), minRank);
        
        filteredList = filteredList.filter((form) => (rankSearch(form, search) <= minRank + 2));

        filteredList = filteredList.sort((a, b) => {
            return rankSearch(a, search) - rankSearch(b, search);
        })
    } else
        filteredList = forms.filter(filter ?? currentEventFilter).sort(compareForms);

    return (
        <div className='interconnect-tile' id={styles.form_list}>
            <div id={styles.header}>
                <h1>Check In/Out Forms</h1>
                <div id={styles.filter_panel}>
                    <label htmlFor='filter' style={{fontStyle: 'italic', gridArea: '1/1/1/1'}}>Filter:</label>
                    <select id='filter' style={{gridArea: '1/2/1/2'}} onChange={(e) => selectFilter(e.target.value)}>
                        <option value='event'>Current Event Groups</option>
                        <option value='in'>Checked In Groups</option>
                        <option value='out'>Checked Out Groups</option>
                        <option value='all'>All Groups</option>
                    </select>
                    <label htmlFor='search-bar' style={{fontStyle: 'italic', gridArea: '2/1/2/1'}}>Search:</label>
                    <input className='search-bar' id='search-bar' onChange={(e) => setSearch(e.target.value)} style={{gridArea: '2/2/2/2'}}/>
                </div>               
            </div>
            <div className="h-scroll" id={styles.table_holder}>
                <table>
                    <thead>
                        <tr>
                            <th>Group/Church</th>
                            <th>Cabin</th> 
                            <th>Gender</th>                           
                            <th>Status</th>
                            <th>Check In</th>
                            <th>Check Out</th>
                            <th>Event Name</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            (filteredList === undefined || filteredList?.length === 0) ?
                                <tr><td style={{fontStyle: 'italic'}}>No forms match the filter.</td><td/><td/><td/><td/><td/><td/></tr> :
                                filteredList.map((form, i) => <CheckInOutFormDetails key={form.id} form={form} index={i}/>)
                        }
                    </tbody>
                </table>
            </div>            
        </div>
    )
}
function rankSearch(form, search) {
    var groupScore = 0;
    let cabinScore = 0;


    var searchWords = search.split(/\s/g);
    var groupNameWords = form.group.split(/\s/g);
    var cabinNameWords = form.cabin.split(/\s/g);

    for(const searchWord of searchWords) {
        let minGroup = Number.MAX_SAFE_INTEGER;
        let minCabin = Number.MAX_SAFE_INTEGER;
        
        for(const cabinWord of cabinNameWords)
            minCabin = Math.min(levenshtein(cabinWord.slice(0, searchWord.length), searchWord), minCabin);

        for(const groupWord of groupNameWords)
            minGroup = Math.min(levenshtein(groupWord.slice(0, searchWord.length), searchWord), minGroup);

        cabinScore += minCabin;
        groupScore += minGroup;
    }

    return Math.min(cabinScore, groupScore);
}

function CheckInOutFormDetails({form, index}) {
    const clazz = (form.status === 'Checked In') ?
        ( (index % 2 === 0) ? styles.light_in  : styles.dark_in) :
        ( (index % 2 === 0) ? styles.light_out : styles.dark_out);

    return (
        <tr key={form.id} className={clazz}>
            <td>{form.group}</td>
            <td>{form.cabin}</td>
            <td>{form.gender}</td>
            <td>{form.status}</td>
            <td>{formatDate(form.check_in?.date)}<br/>{form.check_in?.counselor}</td>
            <td>{formatDate(form.check_out?.date)}<br/>{form.check_out?.staff}</td>
            <td>{form.event_name}</td>
            <td>
                <Link className="interconnect-button" to={`/check-in-out-form/?id=${form.id}`}>View</Link>                
                <button className="interconnect-button" onClick={() => formToPDF(form)}>Print</button>
                {
                    form?.status === 'Checked In' ?
                    <Link className="interconnect-button" to={`/check-in-out-form/?id=${form.id}&check-out=true`}>Check Out</Link> : null
                }
            </td>
        </tr>
    )
}
function formatDate(str) {
    if(str === undefined)
        return '';

    const date = new Date(str);
    date.setTime(date.getTime() + 60 * 60 * 1000 * 16);
    return date.toLocaleDateString('en-US', {month: 'numeric', day: '2-digit', year: '2-digit'});
}

function formToPDF(form) {
    const doc = new jsPDF({
        format: 'letter'
    });

    doc.setProperties({
        title: form?.group + ' Cabin Check In Out Form',
        creator: 'Chautauqua Interconnect'
    });

    addHeader(doc, form);
    addMainText(doc);
    addCheckIn(doc, form);

    if(form?.status === 'Checked Out')
        addCheckOut(doc, form);


    doc.output('dataurlnewwindow', {filename: form?.group + ' Cabin Check In Out Form.pdf'});
}
function addHeader(doc, form) {
    doc.setFont('Signika-Regular', 'normal');
    doc.setFontSize(26);
    doc.text("Cabin Check In/Out Form", 12.575, 34.726);

    doc.rect(119.639, 12.575, 83.686, 25.509);
    doc.line(140.194, 19.943, 200.183, 19.943);
    doc.line(138.944, 27.583, 200.183, 27.583);
    doc.line(157.294, 35.233, 200.183, 35.233);

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14);
    doc.text("Group:", 122.760, 19.430);
    doc.text("Cabin:", 122.760, 27.107);
    doc.text("Bed Numbers:", 122.760, 34.806);
    doc.setFont('helvetica', 'normal');
    doc.text(form?.group, 142.194, 19.430);
    doc.text(`${form?.cabin} (${form?.gender})`, 140.944, 27.107);
    doc.text(form?.bed_numbers, 159.294, 34.806);
}
function addMainText(doc) {
    doc.setFontSize(12);
    doc.text('We are excited to have you as our guest and we look forward to serving you. As we strive to ensure that your time at Chautauqua is a great experience we feel it is imperative to keep our facilities clean and in working order. With this in mind, we are asking individual counselors in charge of their groups to fill out this form and turn it into the office in case we need to make any repairs.',
        12.618, 42.971, {align: 'justify', maxWidth: 190.582, lineHeightFactor: 1.5}
    );
    doc.text('We understand that our facilities are in some cases decades old and show signs of use. Please indicate in the space provided if there are any major damages to your cabin/dorm upon your arrival. The church will be charged for damages incurred due to horseplay or inappropriate behavior. The cost of any repairs due to damage during your stay can be obtained from the office.',
        12.618, 70.947, {align: 'justify', maxWidth: 190.582, lineHeightFactor: 1.5}
    );
}
function addCheckIn(doc, form) {
    doc.setFont('Signika-Regular', 'normal');
    doc.setFontSize(18);
    doc.text('Present in Cabin (Check In)', 12.575, 102.936, {baseline: 'top'});
    doc.line(12.575, 116.586, 18.575, 116.586);
    doc.line(39.290, 116.586, 45.290, 116.586);
    doc.line(70.709, 116.586, 76.709, 116.586);
    
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(12);
    doc.text('Broom', 19.228, 111.822, {baseline: 'top'});
    doc.text('Dust Pan', 45.972, 111.822, {baseline: 'top'});
    doc.text('Waste Can', 77.127, 111.822, {baseline: 'top'});

    doc.setFontSize(16);
    if (form?.check_in?.broom) doc.text('X', 13.873, 111.206, {baseline: 'top'});
    if (form?.check_in?.dust_pan) doc.text('X', 40.588, 111.206, {baseline: 'top'});
    if (form?.check_in?.waste_can) doc.text('X', 72.007, 111.206, {baseline: 'top'});

    doc.setFont('Signika-Regular', 'normal');
    doc.setFontSize(18);
    doc.text('Preexisting Major Damages (Check In)', 12.575, 122.992, {baseline: 'top'});
    doc.rect(12.579, 131.402, 190.578, 16.716);

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(12);
    doc.text(form?.check_in?.major_damages?.replaceAll('\n', ' '), 13.579, 133.402,
        {align: 'justify', maxWidth: 188.5820, lineHeightFactor: 1.5, baseline: 'top'}
    );

    doc.text('Counselor Name:', 12.571, 150.435, {baseline: 'top'});
    doc.text(form?.check_in?.counselor, 49.676, 150.435, {baseline: 'top'});
    doc.text('Date:', 125.849, 150.435, {baseline: 'top'});
    doc.text(formatDate(form?.check_in?.date), 138.901, 150.435, {baseline: 'top'});

    doc.line(48.130, 154.855, 65.000 + 48.130, 154.855);
    doc.line(136.789, 154.855, 24.715 + 136.789, 154.855);

    doc.text(`By inputting my name and today's date, I, ${form?.check_in?.counselor?.trim()}, certify that the above information is correct to the best of my knowledge and that charges for any new damages will be paid for by ${form?.group?.trim()}.`,
        12.618, 159.177, {align: 'justify', maxWidth: 190.582, lineHeightFactor: 1.25, baseline: 'top'}
    );
}
function addCheckOut(doc, form) {
    doc.line(12.453, 181.786, 12.453 + 190.500, 181.786);

    doc.setFont('Signika-Regular', 'normal');
    doc.setFontSize(18);
    doc.text('Present in Cabin (Check Out)', 12.575, 187.579, {baseline: 'top'});
    doc.line(12.575, 201.492, 18.575, 201.492);
    doc.line(39.290, 201.492, 45.290, 201.492);
    doc.line(70.709, 201.492, 76.709, 201.492);
    
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(12);
    doc.text('Broom', 19.228, 196.465, {baseline: 'top'});
    doc.text('Dust Pan', 45.972, 196.465, {baseline: 'top'});
    doc.text('Waste Can', 77.127, 196.465, {baseline: 'top'});

    doc.setFontSize(16);
    if (form?.check_out?.broom) doc.text('X', 13.873, 195.849, {baseline: 'top'});
    if (form?.check_out?.dust_pan) doc.text('X', 40.588, 195.849, {baseline: 'top'});
    if (form?.check_out?.waste_can) doc.text('X', 72.007, 195.849, {baseline: 'top'});

    doc.setFont('Signika-Regular', 'normal');
    doc.setFontSize(18);
    doc.text('Preexisting Major Damages (Check Out)', 12.575, 204.433, {baseline: 'top'});
    doc.rect(12.579, 212.687, 190.578, 16.716);

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(12);
    doc.text(form?.check_out?.major_damages?.replaceAll('\n', ' '), 13.579, 214.687,
        {align: 'justify', maxWidth: 188.5820, lineHeightFactor: 1.5, baseline: 'top'}
    );

    doc.text('Staff Name:', 12.571, 233.116, {baseline: 'top'});
    doc.text(form?.check_out?.staff, 38.043, 233.116, {baseline: 'top'});
    doc.text('Date:', 114.215, 233.116, {baseline: 'top'});
    doc.text(formatDate(form?.check_out?.date), 127.267, 233.116, {baseline: 'top'});

    doc.line(36.497, 237.410, 36.497 + 65.000, 237.410);
    doc.line(125.156, 237.410, 125.156 + 24.715, 237.410);

    doc.text(`By inputting my name and today's date, I, ${form?.check_out?.staff}, certify that the above information is correct to the best of my knowledge.`,
        12.618, 241.852, {align: 'justify', maxWidth: 190.582, lineHeightFactor: 1.25, baseline: 'top'}
    );
}

export function CIOFormSubmitted({ setShowNavBar }) {
    useEffect(() => setShowNavBar(false));

    const [searchParams, ] = useSearchParams();
    const [form, setForm] = useState();

    const id = searchParams.get('id');
    useEffect(() => {
        getCheckInOutForm(id).then(data => setForm(data));
    }, [id]);

    return (
        <div id={styles.submitted_background}>
            <div id={styles.submitted_foreground}>
                <h1>Check In/Out Form Submitted</h1>
                <h2>Thank you!</h2>
                <h3>Please go to this events check-in location to complete the check-in process</h3>
                <button className="interconnect-button" onClick={() => formToPDF(form)}
                    style={{color: 'black', padding: '8px 16px', fontSize: '1.25rem'}}>Print Form (PDF)</button>  
            </div>
        </div>
    );
}